<template>
  <v-app id="inspire">
    <v-app-bar
      app
      color="white"
      flat
    >
      <v-container class="py-0 fill-height">
        <v-layout row class="display-1 ml-2">
          <div id="font">
            Simples
          </div>

          <div id="font" class="primary--text">
            Medic
          </div>
        </v-layout>

        <v-spacer />

        <v-btn
          title="Ajuda"
          icon
          @click="retornarHelp()"
        >
          <v-icon title="Ajuda">
            info
          </v-icon>
        </v-btn>

        <v-btn title="Logout" text icon color="primary" @click="logout()">
          <v-icon v-if="user.tecnico" title="Logout">
              logout
          </v-icon>
          <v-icon v-else title="Logout">
              power_settings_new
          </v-icon>
        </v-btn>
      </v-container>
    </v-app-bar>

    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <v-col cols="2">
            <v-sheet rounded="lg">
              <v-list class="pa-1" color="transparent">
                <v-list-item avatar>
                  <v-list-item-avatar>
                    <v-img :src="require('../assets/IconAdmin2.png')" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ this.$store.getters.usuario.nome }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-list class="pt-0">
                <v-divider />
                <v-list-item
                  v-for="item in items"
                  :key="item.title"
                  :to="{path:item.rota}"
                >
                  <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-action>

                    <v-list-item-title>{{ item.title }}</v-list-item-title>

                </v-list-item>

                <v-list-group
                  prepend-icon="settings"
                  color="primary"
                >
                  <template v-slot:activator class="">
                    <v-list-item >
                      <v-list-item-title >Configurações</v-list-item-title>
                    </v-list-item>
                  </template>

                  <v-list-item
                    v-for="(admin, i) in admins"
                    :key="i"
                    :to="{path:admin[2]}"
                  >
                    <v-list-item-title v-text="admin[0]" />
                    <v-list-item-action>
                      <v-icon v-text="admin[1]" />
                    </v-list-item-action>
                  </v-list-item>
                </v-list-group>
              </v-list>
            </v-sheet>
          </v-col>

          <v-col>
            <v-sheet
              min-height="70vh"
              rounded="lg"
            >
              <router-view/>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */

import administradorUnidadeService from "../services/administradorUnidade.service";
import HelperAdministradorUnidade from "./../components/helper/Helper";
import { getToken, setToken } from "../store/auth";

export default {
name: "App",
components: {
  HelperAdministradorUnidade
},
data() {
  return {
    links: [
        'Dashboard',
        'Messages',
        'Profile',
        'Updates',
      ],
  drawer: null,
  intervalos: [],
  dialogHelp:false,
  blockMethod:false,
  chamouListaHelp:false,
      listaHelp:[],
       admins: [
          ['Alterar nome', 'person','editarNomeAdministradorUnidade'],
          ['Alterar senha', 'vpn_key','editarSenhaAdministradorUnidade'],
    ['Alterar cor do card da unidade', 'color_lens','coresUnidade'],			
        ],
        servicos: [
          ['Adicionar peso', 'person','EditarNomeAdministrador'],
        ],
      items: [
        { title: 'Início', icon: 'dashboard' ,rota:'/dashboardUnidade'},
        { title: 'Médicos', icon: 'groups' ,rota:'/MetricasMedico'},
        { title: 'Técnicos', icon: 'enhanced_encryption' ,rota:'/listaTecnicosUnidade'}, 
        { title: 'Atendentes', icon: 'groups' ,rota:'/listaAtendentesUnidade'},
        { title: 'Recepcionistas', icon: 'groups' ,rota:'/listaRecepcionistasUnidade'},
        { title: 'Apoio', icon: 'person' ,rota:'/listaApoioUnidade'},
        { title: 'Usuarios', icon: 'person' ,rota:'/usuarios'},
        { title: 'Locais', icon: 'place' ,rota:'/listaLocaisUnidade'},
        { title: 'Serviços', icon: 'add' ,rota:'/servicosUnidade'},
        { title: 'Painéis', icon: 'tv' ,rota:'/listaPaineisUnidade'},       
           
            ],
      right: null,
   recepcionista: [
      ['Create', 'add','cadastrarRecepcionista'],
      ['Read', 'insert_drive_file','rotarecepcionista2'],
      ['Update', 'update','rotarecepcionista3'],
      ['Delete', 'delete','rotarecepcionista4']
    ],
    atendente: [
      ['Create', 'add','rota1'],
      ['Read', 'insert_drive_file','rota2'],
      ['Update', 'update','rota3'],
      ['Delete', 'delete','rota4']
    ]
  };
},
props: {
  source: String
},
 created() {
   var i1 = setInterval(this.refreshToken, 21600000);
   this.intervalos.push(i1);
   this.user = this.$store.getters.usuario
 },
methods: {
alterarDialogHelp(){
       this.dialogHelp = false
},

refreshToken() {  
    console.log('token antes:',getToken());

    administradorUnidadeService.administradorUnidade
      .refreshToken(getToken())
      .then(rsp => { 
        console.log('rsp refreshToken',rsp);          
        if(rsp.status == 200){
          setToken(rsp.data.token)
          console.log('token dps',getToken());
          
          this.socket.close()
          this.socket = io.connect(socketService.SOCKET_URL, {
            query: {
              token: getToken()
            }
          });
          this.chamarSocket();  
          // this.retornarMedicos()
        }                  
      })
      .catch(err => {
        // handle your error here
        console.log(err)
      })      
  },


retornarHelp(){

  if(!this.blockMethod){

  this.blockMethod = true
  if(this.chamouListaHelp){
     this.dialogHelp = true  
     this.blockMethod = false
     return
  }       

  administradorUnidadeService.administradorUnidade
      .retornarHelp(this.user.tipo)
      .then(rsp => { 
        console.log('rsp retornarHelp:',rsp);          
        if(rsp.status == 200){			  
      this.listaHelp = this.groupBy (rsp.data,"idTituloHelp") 
      this.chamouListaHelp = true 
      this.dialogHelp = true    
    }   
    this.blockMethod = false
      })
      .catch(err => {
    //handle your error here
    this.blockMethod = false
        console.log(err)
  }) 	
  }
},
limparIntervalos() {
    this.intervalos.forEach(clearInterval);
  },

  logout() {
    console.log("em logout..");
    //this.$router.push("/login");
    this.$store
      .dispatch("FedLogOut")
      .then(rsp => {
    console.log('11111111');  
    this.limparIntervalos(); 
    this.$router.push("/login");   
        
        if (r) {
          
        }
        
      })
      .catch(error => {
        //   this.progress = false;
        //   this.alert = true;
        //   this.msg = error;
      });
},
groupBy(collection, property) {
    var i = 0,
      val, index,
      values = [],
      result = [];
    for (; i < collection.length; i++) {
      val = collection[i][property];
      index = values.indexOf(val);
      if (index > -1)
        result[index].push(collection[i]);
      else {
        values.push(val);
        result.push([collection[i]]);
      }
    }
    return result;
  },
},
mounted() {
  console.log(this.$store.getters.usuario);
  this.user = this.$store.getters.usuario
  console.log('mouted admUnidade, user:', this.user);
 // this.$router.push("/dashboardUnidade")
}  
};
</script>

<style scoped>
.navbar {
  border-top-left-radius: 35px; border-bottom-left-radius: 35px; width: 250px;  margin-left: 20px; position: absolute; z-index: 1;
}
</style>